// The shared To Do lists the app / AI / database make by name: ONE per vessel (sql/test-fixes-2.sql, hc_todo_system_name)
// and visible to EVERY login with To Do view, whoever created them (the merge of duplicates may have given one a creator).
export const SYSTEM_LISTS = ['Inbox', 'Defects', 'Renewals', 'LSA / FFE', 'Refit', 'ISM Findings']
const KEYS = SYSTEM_LISTS.map(n => n.toLowerCase())
export const isSystemList = name => KEYS.includes(String(name || '').trim().toLowerCase())
